<template>
  <el-tooltip :content="actionLabel" placement="top-start">
    <button
      class="sensitive-view-button" :class="{ 'is-loading': loading }" type="button"
      :disabled="disabled || loading"
      :aria-label="actionLabel"
      :aria-pressed="String(revealed)"
      @click="$emit('click')"
    >
      <svg-icon :icon-class="loading ? 'loading' : 'iconEye'" />
    </button>
  </el-tooltip>
</template>

<script>
export default {
  name: 'SensitiveViewButton',
  props: {
    revealed: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    label: { type: String, default: '' }
  },
  computed: {
    actionLabel() {
      return this.label || this.$t(this.revealed ? 'sensitiveView.hide' : 'sensitiveView.show');
    }
  }
};
</script>

<style scoped lang="scss">
.sensitive-view-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-left: 8px;
  padding: 2px;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  transition: transform 0.2s;

  &:hover:not(:disabled) { transform: scale(1.1); }
  &:focus-visible { outline: 2px solid #00A551; outline-offset: 2px; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
  &.is-loading .svg-icon { animation: rotating 1s linear infinite; }
}

@keyframes rotating {
  to { transform: rotate(360deg); }
}
</style>
